import { ReactNode } from "react";

import { Row } from "@tanstack/react-table";

import { type ConfigurationViewConfig } from "./datatable-configuration-view/datatable-configuration-view";
import { DatatableBody } from "./datatable-body";
import { DatatableCellCacheProvider } from "./datatable-cell-cache";
import { DatatableRowCacheProvider } from "./datatable-row-cache";
import { DatatableRowData, DatatableRowDataWithCacheKey } from "./datatable-types";

export interface DatatableNoContextProps<TData extends DatatableRowData> {
  children?: ReactNode;
  viewKey: string;
  config?: ConfigurationViewConfig;
  getRowPath?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => string;
  onRowClick?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => void;
  onRowHover?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => void;
  isRowSelected?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => boolean;
}

export function DatatableNoContext<TData extends DatatableRowData>({
  children,
  viewKey,
  config,
  getRowPath,
  onRowClick,
  onRowHover,
  isRowSelected,
}: DatatableNoContextProps<TData>): ReactNode {
  return (
    <DatatableRowCacheProvider>
      <DatatableCellCacheProvider viewKey={viewKey}>
        <DatatableBody<TData>
          config={config}
          getRowPath={getRowPath}
          onRowClick={onRowClick}
          onRowHover={onRowHover}
          isRowSelected={isRowSelected}
        />
        {children}
      </DatatableCellCacheProvider>
    </DatatableRowCacheProvider>
  );
}
